import React, { useState, useEffect } from 'react';
import DesktopEnvironment from '../components/DesktopEnvironment';
import MobileEnvironment from '../components/MobileEnvironment';
import { CookieConsent } from '../components/LegalPages';

const Home = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        window.addEventListener('resize', handleResize);

        // Check for referral code logic that was in App.js
        const params = new URLSearchParams(window.location.search);
        const refCode = params.get('ref');
        if (refCode) {
            localStorage.setItem('paradise_referral', refCode);
            // We keep the URL clean
            const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            window.history.replaceState({ path: newUrl }, '', newUrl);
        }

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="App">
            {isMobile ? <MobileEnvironment /> : <DesktopEnvironment />}
            <CookieConsent />
        </div>
    );
};

export default Home;
